/**
 * Singleton settings fetcher.
 *
 * Instead of Navbar, Footer and HomeScreen each calling /api/settings
 * independently on mount (which creates 3 sequential API trips in the
 * network chain), all consumers share a single in-flight Promise so the
 * request is made exactly once per page load.
 */

let settingsPromise: Promise<Record<string, any>> | null = null;

export function fetchSettings(): Promise<Record<string, any>> {
  if (!settingsPromise) {
    settingsPromise = fetch("/api/settings")
      .then((res) => {
        if (!res.ok) throw new Error(`Settings fetch failed: ${res.status}`);
        return res.json();
      })
      .catch((err) => {
        // Reset so a future call can retry after a network error
        settingsPromise = null;
        console.warn("Failed to fetch settings:", err);
        return {} as Record<string, any>;
      });
  }
  return settingsPromise;
}

export function clearSettingsCache(): void {
  settingsPromise = null;
}

